import { Injectable } from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { NewFolderComponent } from './new-folder.component';

@Injectable()
export class NewFolderService {

  constructor(private dialog: MatDialog) { }

  openModal(): Observable<string> {
    let dialogRef: MatDialogRef<NewFolderComponent>;
    dialogRef = this.dialog.open(NewFolderComponent, {disableClose: true});
    dialogRef.updateSize('380px');
    return dialogRef.afterClosed();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/new-folder/new-folder.service.ts